import React, { Component } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Footer from '../common/Footer';
import Header from '../common/Header';
import ajax from '../utils/ajax'
import { toUpper } from 'lodash'
import $ from 'jquery';
import functions from '../utils/functions'


class About extends Component {

    state = {
        userId: functions.sessionGuard(),
        username: '',
        tourId: '',
        tourName: '',
        tourPoster: '',
        tourDesc: '',
        priced: '00 UGX',
        trending: false,
        allfun: false,
        allOldfun: false,
        dialog: false,
        currentPage: 1,
        metaData: false,
        processing: false,
        allOldfunTrick: false,
        searchEvent: false,
        fallback: false,
        nodata: false,
        serachTerm: ""

    }

    componentDidMount() {

        // if (!this.props.match.params) {
        //     this.props.history.push('/')
        // } else {
        //     this.setState(
        //         {
        //             tourId: this.props.match.params.fun,
        //         },
        //         () => {
        //             this.getEventInfo()
        //         }
        //     )
        // }
    }

    render() {

        const soon = this.state.allfun

        return (
            <>

                <body className="datepicker_mobile_full">
                    {/* <!-- Remove this className to disable datepicker full on mobile --> */}

                    <div id="page">

                        <header className="header menu_fixed">
                            {/* <div id="preloader"><div data-loader="circle-side"></div></div> */}
                            {/* <!-- /Page Preload --> */}
                            <div id="logo">
                                <a href="/">
                                <img src="../assets/img/biglogo.png" width="100" height="50" alt="" className="logo_normal" />
                                <img src="../assets/img/biglogo.png" width="100" height="50" alt="" className="logo_sticky" />
                                </a>
                            </div>
                            <ul id="top_menu">
                                {/* <li><a href="cart-1.html" className="cart-menu-btn" title="Cart"><strong>4</strong></a></li> */}
                                <li><a href="#sign-in-dialog" id="sign-in" className="login" title="Sign In">Sign In</a></li>
                            </ul>
                            {/* <!-- /top_menu --> */}
                            <a href="#menu" className="btn_mobile">
                                <div className="hamburger hamburger--spin" id="hamburger">
                                    <div className="hamburger-box">
                                        <div className="hamburger-inner"></div>
                                    </div>
                                </div>
                            </a>
                            <nav id="menu" className="main-menu">
                                <ul>
                                    <li><span><a href="/">Home</a></span>
                                    </li>
                                    <li><span><a href="http://myportal.funug.co/" target='__blank'>Add Fun Event</a></span></li>
                                    <li><span><a href="how-it-works">How it Works</a></span>
                                    </li>
                                    {/* <li><span><a href="#0">Hotels</a></span>
                                    </li>
                                    <li><span><a href="adventure.html">Adventure</a></span></li> */}
                                </ul>
                            </nav>
                        </header>
                        {/* <!-- /header --> */}


                        <main>

                            <section class="hero_in general">
                                <div class="wrapper">
                                    <div class="container">
                                        <h1 class="fadeInUp"><span></span>About Funug</h1>
                                    </div>
                                </div>
                            </section>
                            {/* <!--/hero_in--> */}

                            <div class="container margin_80_55">
                                <div class="main_title_2">
                                    <span><em></em></span>
                                    <h2>Why Choose Funug</h2>
                                    <p>Our goal is to make you and your clients break even.</p>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6">
                                        <a class="box_feat" href="#0">
                                            <i class="pe-7s-headphones"></i>
                                            <h3>Help Direct Line</h3>
                                            <p>Our friendly and able teams are available 24/7 to assist you or your clients should there be need of any form of help we dont take enquiries lightly. </p>
                                        </a>
                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <a class="box_feat" href="#0">
                                            <i class="pe-7s-credit"></i>
                                            <h3>Secure Payments</h3>
                                            <p>All payments that are processed through our platform are end to end encrypted and very secure, you can never lose money with us </p>
                                        </a>
                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <a class="box_feat" href="#0">
                                            <i class="pe-7s-chat"></i>
                                            <h3>Big Social Presence</h3>
                                            <p>Take advantage of our social presence and availability to effortlessly sell, your do not need to know anyone because they know us. </p>
                                        </a>
                                    </div>
                                </div>
                                {/* <!--/row--> */}
                            </div>
                            {/* <!-- /container --> */}

                            {/* <!--/bg_color_1--> */}
                            {/* <!--/container--> */}
                        </main>


                        {/* <!-- /main --> */}

                        <Footer />

                        {/* <!--/footer--> */}
                    </div>
                    {/* <!-- page --> */}

                </body>
            </>
        )
    }
}
export default About